import { render, staticRenderFns } from "./ImportItems.vue?vue&type=template&id=4b34edef&"
import script from "./ImportItems.vue?vue&type=script&lang=js&"
export * from "./ImportItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports